import React from "react";
import TextField from '@material-ui/core/TextField'
import FormControl  from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'

import RenderError from '../render-error'

interface YourDetailsProps {
  [key: string]: any
}

const YourDetails: React.FC<YourDetailsProps> = (props:any) => {

  const appeal = (window as any).KEW.collections.appeal[0]

  return (
    <>
      <div className="row">
        <div className="your-details clearfix box">
          <h2>Your details</h2>
          <fieldset className="row">
            <legend>Your details</legend>
            <div className="medium-6 columns">
              <div className="input-container select" id="title-container">
                <FormControl>
                  <InputLabel htmlFor="title">Title</InputLabel>
                  <Select
                    variant="outlined"
                    name="salutation"
                    id="title"
                    autoComplete="honorific-prefix"
                    inputProps={{
                      "aria-describedby": "title_error"
                    }}
                    error={props.submitCount > 0 && props.errors.salutation ? true : false}
                    value={props.values.salutation || ''}
                    onChange={props.handleChange}>
                    {
                      Object.entries(props.titles).map((title:any, index:any) => {
                        return (
                          <MenuItem key={index} value={title[0]}>{title[1]}</MenuItem>
                        )
                      })
                    }
                  </Select>
                </FormControl>
                <RenderError name="salutation" id="title_error" {...props} />
              </div>
              <div className="input-container">
                <TextField
                  type="text"
                  variant="outlined"
                  id="first-name"
                  name="first_name"
                  label="First name"
                  autoComplete="given-name"
                  inputProps={{
                    "aria-describedby": "first-name_error"
                  }}
                  error={props.submitCount > 0 && props.errors.first_name ? true : false}
                  value={props.values.first_name}
                  onChange={props.handleChange} />
                <RenderError name="first_name" id="first-name_error" {...props} />
              </div>
              <div className="input-container">
                <TextField
                  type="text"
                  variant="outlined"
                  id="last-name"
                  name="last_name"
                  label="Last name"
                  autoComplete="family-name"
                  inputProps={{
                    "aria-describedby": "last-name_error"
                  }}
                  error={props.submitCount > 0 && props.errors.last_name ? true : false}
                  value={props.values.last_name}
                  onChange={props.handleChange} />
                <RenderError name="last_name" id="last-name_error" {...props} />
              </div>
            </div>
            <div className="medium-6 columns">
              <div className="input-container">
                <TextField
                  type="text"
                  variant="outlined"
                  id="email-address"
                  name="email"
                  label="Email address"
                  autoComplete="email"
                  inputProps={{
                    "aria-describedby": "email-address_error"
                  }}
                  error={props.submitCount > 0 && props.errors.email ? true : false}
                  value={props.values.email}
                  onChange={props.handleChange} />
                <RenderError name="email" id="email-address_error" {...props} />
              </div>
              <div className="input-container">
                <TextField
                  type="tel"
                  variant="outlined"
                  id="phone-number"
                  name="phone"
                  label="Phone number (optional)"
                  autoComplete="tel"
                  inputProps={{
                    "aria-describedby": "phone-number_error"
                  }}
                  error={props.errors.phone ? true : false}
                  value={props.values.phone}
                  onChange={props.handleChange} />
                <RenderError name="phone" id="phone-number_error" {...props} />
              </div>
            </div>
            <div className="large-12 columns"></div>
            { appeal.membership_number_active &&
              <>
                <div className="medium-6 columns">
                  <div className="input-container">
                  <TextField
                    type="tel"
                    variant="outlined"
                    id="membership-number"
                    name="membership_number"
                    label="Membership number (optional)"
                    inputProps={{
                      "aria-describedby": "membership-number_error"
                    }}
                    error={props.errors.membership_number ? true : false}
                    value={props.values.membership_number}
                    onChange={props.handleChange} />
                  <RenderError name="membership_number" id="membership-number_error" {...props} />
                    <span className="description">
                      {appeal.membership_number_explanatory_copy}
                    </span>
                  </div>
                </div>
                <div className="medium-6 columns">
                  <div className="input-container">
                    <p className="info">
                      {appeal.membership_help_copy}
                    </p>
                  </div>
                </div>
              </>
            }
          </fieldset>
        </div>
      </div>
    </>
  );
};

export default YourDetails;